import { Component, OnInit } from '@angular/core';
import {BaseModalComponent, FileLinkModel, ToFileLinkModelPipe} from "common-shared";
import {SpecLineModel} from "../../../properties/models/spec-line.model";

@Component({
  selector: 'app-file-link-edit-modal',
  templateUrl: './file-link-edit-modal.component.html',
  styles: [
  ],
  providers: [ToFileLinkModelPipe]
})
export class FileLinkEditModalComponent extends BaseModalComponent implements OnInit {
  fileLink: FileLinkModel;
  spec: SpecLineModel;
  title: string;

  constructor(private toFileLinkModelPipe: ToFileLinkModelPipe) {
    super();
  }

  ngOnInit(): void {
    this.fileLink ??= this.toFileLinkModelPipe.transform(this.spec.Value);
  }

  serializeAndClose() {
    this.close(JSON.stringify(this.fileLink));
  }
}
